import React from "react";
import SpecItem from "../common/SpecItem";
import type { SpecsSectionPropsType } from "../Specifications";
import List from "../../../../styles/atoms/List";
import Text from "../../../../styles/atoms/Text";

const SectionTransmission = ({ product, title, specs }: SpecsSectionPropsType): JSX.Element => {
    return (
        <div>
            <Text tag="h4" variant="h6">
                {title}
            </Text>
            <List variant="specs" tag="dl">
                {product.transmission.gearbox && specs.gearbox && (
                    <SpecItem title={specs.gearbox.title} value={product.transmission.gearbox} />
                )}

                {product.transmission.name && specs.transmission && (
                    <SpecItem title={specs.transmission.title} value={product.transmission.name} />
                )}
            </List>
        </div>
    );
};

export default SectionTransmission;
